// DOM Content Loaded
document.addEventListener("DOMContentLoaded", function () {

    document.body.addEventListener('click', function (e) {
        const accordionTargetHeader = e.target.closest('.js-accordion');
        if (accordionTargetHeader) {
            const accordionTargetItem = accordionTargetHeader.parentNode.closest('.accordion__item');
            const accordionTargetCollapse = accordionTargetItem.querySelector('.accordion__collapse');
            const accordionCollapses = accordionTargetHeader.parentNode.closest('.accordion').querySelectorAll('.accordion__collapse');

            // Slide up tous les autres éléments de l'accordéon
            for (const accordionCollapse of accordionCollapses) {
                if (accordionCollapse != accordionTargetCollapse) {
                    const accordionItem = accordionCollapse.parentNode.closest('.accordion__item');
                    accordionSlideUp(accordionItem, accordionCollapse);
                }
            }

            // Slide down l'élément ciblé s'il n'est pas actif
            if (accordionTargetItem.classList.contains('accordion__item--active')) {
                accordionSlideUp(accordionTargetItem, accordionTargetCollapse);
            } else {
                accordionSlideDown(accordionTargetItem, accordionTargetCollapse);
            }
        }
    });

    /**
     * Accordion slide down
     */

    const accordionSlideDown = (item, collapse) => {
        item.classList.add('accordion__item--active');

        collapse.style.height = 'auto';
        const collapseHeight = collapse.clientHeight + 'px';
        collapse.style.height = '0px';
        setTimeout(function () {
            collapse.style.height = collapseHeight;
        }, 0);
    }

    /**
     * Accordion slide up
     */

    const accordionSlideUp = (item, collapse) => {
        collapse.style.height = '0px';
        item.classList.remove('accordion__item--active');
    }
});